























































import Vue from 'vue';
import { HTTP } from '@/utils/httpCommonUtil'
import VueSimpleSpinner from 'vue-simple-spinner'
import { BallPulseLoader } from 'vue-loaders';

export default Vue.component('specialty-modal', {
  name: 'SpecialtyModal',
  data () {
    return {
      showDropdown: false,
      loadingInitialData: false,
      searchInput: '',
      performSearchTimeout: null,
      searchResults: [],
      searchCountResults: 0,
      allowForceResultsMaximum: 150,
      allowForceResults: false,
      processing: false,

      systemSpecialtiesFromServer: [],
      systemSpecialtiesFiltered: [],
      searchText: ''
    }
  },
  components: {
    VueSimpleSpinner,
    BallPulseLoader
  },
  created: function () {
    this.getSystemSpecialties();
  },
  mounted: function () {
    (this.$refs as any).search.focus();
    (this.$refs as any).search.select();
  },
  filters: {
    shortName (shortName: string ) {
      if (shortName && shortName.length) {
        return '(' + shortName + ')';
      }
      return '';
    }
  },
  methods: {
    getSystemSpecialties () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 0);
      HTTP.get('/api/specialtyTypes')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        console.log('response: ');
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving Specialties.");
        }
        self.systemSpecialtiesFromServer = response.data.data;
        self.systemSpecialtiesFromServer.forEach(function (specialty: any) {
          specialty.searchText = specialty.specialty.toLowerCase() + ' ' + specialty.specialtyShortName.toLowerCase();
        })
        self.systemSpecialtiesFiltered = self.systemSpecialtiesFromServer;
      })
      .catch(function () {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving System Specialties.'
        });
      })
    },
    searchTextChange () {
      let self = this as any;
      let tempSystemSpecialtiesFiltered: any[] = [];
      let tempSearchText = self.searchText.toLowerCase();
      for (let i = 0; i < self.systemSpecialtiesFromServer.length; i++) {
        if (self.systemSpecialtiesFromServer[i].searchText.indexOf(tempSearchText) > -1) {
          tempSystemSpecialtiesFiltered.push(self.systemSpecialtiesFromServer[i]);
        }
      }
      self.systemSpecialtiesFiltered = tempSystemSpecialtiesFiltered;
    },
    selectSpecialty (specialty: any) {
      this.$emit('selected-event', {id: specialty.id, specialtyId: specialty.id, name: specialty.specialty} );
    },
    cancel () {
      this.$emit('cancel-event');
    },

  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsReusable/SpecialtyModal.vue